import { AxiosPromise } from 'axios';
import { IGetStudentCoupons, IGetStudentCouponTypes, IStudentCouponReq } from '../models/coupons2.model';
import axios from 'axios';

const uri = '/mgmt/coupons';

export const getStudentCouponTypes = (campusCode: string, memberCode: string): AxiosPromise<IGetStudentCouponTypes> => {
  return axios.get(`${uri}/${campusCode}/${memberCode}`);
}

export const getStudentCoupons = (memberCode: string): AxiosPromise<IGetStudentCoupons> => {
  return axios.get(`${uri}/${memberCode}/coupons`);
}

export const createCoupon = (couponCode: number, memberCode: string, data: IStudentCouponReq): AxiosPromise => {
  return axios.post(`${uri}/${couponCode}/${memberCode}`, data);
};

export const createCouponWithAmount = (couponCode: number, memberCode: string, data: IStudentCouponReq): AxiosPromise => {
  return axios.post(`${uri}/${couponCode}/${memberCode}/amount`, data);
};

export const deleteCoupon = (couponCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${couponCode}`);
};
